import UserGroupMembership from '@src/components/usergroup/view/UserGroupMembership';
import React from 'react';

const UserGroupMembershipPage = () => <UserGroupMembership />;

export default UserGroupMembershipPage as any;
